<template>
  <div class="mobile-nav col-flex bg-white fixed rounded-lg top-28 px-4 py-4 text-left gap-y-7" style="color: #0A1045;">
    <img src="../assets/img/products.svg" alt="">
  </div>
</template>

<script>
import {ref, inject} from "vue"
export default { 
    setup() {
        
    }
}
</script>

<style scoped>
  /* .mobile-nav {
    width: 256px;
    height: 209px;

    background: #FFFFFF;

    border: 1px solid #EBEBEB;
    box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.07), 0px 10px 32px -4px rgba(24, 39, 75, 0.05);
    border-radius: 15px;
  }
  button {
    border: 1px solid #D9DDEE;
    border-radius: 20px;
    height: 50px;
  } */
</style>